export default "__VITE_ASSET__CoJlAnpk__"